var map = {
	"./atlas.png": 6242,
	"./digital.png": 7021,
	"./jn.png": 3997,
	"./m1.png": 784,
	"./mgu.png": 1050,
	"./parimatch.png": 4582,
	"./playboy.png": 7958,
	"./sluhay.png": 484,
	"./sw.png": 8495,
	"./tk.png": 9956,
	"./twn.png": 3879,
	"./unn.png": 4597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1417;